import { cannotAccessList } from '@/assets/cannotAccessList'
export default [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      title: 'login',
      skipAuth: true,
    },
  },
  {
    path: '/customer-login/:username?',
    name: 'CustomerLogin',
    component: () => import('@/views/pages/CustomerLogin.vue'),
    meta: {
      layout: 'blank',
      title: 'login',
      skipAuth: true,
      isCustomer: true,
    },
  },
  {
    path: '/customer-info/:username?',
    name: 'CustomerUserDetails',
    component: () => import('@/views/pages/customer/CustomerDetails.vue'),
    meta: {
      layout: 'content',
      title: 'menu.customerInfo',
      requireAuth: true,
      cannotAccess: cannotAccessList['CustomerUserDetails'],
      isCustomer: true,
    },
  },
  {
    path: '/customer-attendance/:username',
    name: 'CustomerUserAttendance',
    component: () => import('@/views/pages/user/Customer/CustomerAttendance.vue'),
    meta: {
      layout: 'content',
      title: 'attendanceRecord',
      requireAuth: true,
      cannotAccess: cannotAccessList['CustomerUserAttendance'],
      isCustomer: true,
    },
  },
  {
    path: '/customer-order/:username',
    name: 'CustomerUserOrderList',
    component: () => import('@/views/pages/user/Order/OrderList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.order',
      requireAuth: true,
      cannotAccess: cannotAccessList['CustomerUserOrderList'],
      isCustomer: true,
    },
  },
  {
    path: '/pay',
    name: 'PayTuitionList',
    component: () => import('@/views/pages/user/PayTuition/PayTuitionList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.payTuition',
      requireAuth: true,
      cannotAccess: cannotAccessList['PayTuitionList'],
    },
  },
  {
    path: '/pay/payment/:id',
    name: 'PayTuitionPayment',
    component: () => import('@/views/pages/user/PayTuition/PayTuitionPayment.vue'),
    meta: {
      layout: 'content',
      title: 'menu.payTuition',
      requireAuth: true,
      cannotAccess: cannotAccessList['PayTuitionPayment'],
    },
  },
  {
    path: '/timetable',
    name: 'Timetable',
    component: () => import('@/views/pages/user/Timetable/Timetable.vue'),
    meta: {
      layout: 'content',
      title: 'menu.timetable',
      requireAuth: true,
      cannotAccess: cannotAccessList['Timetable'],
    },
  },
  {
    path: '/timetable/service/create/:date?',
    name: 'CreateAppointment',
    component: () => import('@/views/pages/user/Timetable/AppointmentDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createBooking',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateAppointment'],
    },
  },
  {
    path: '/timetable/service/:id',
    name: 'AppointmentDetails',
    component: () => import('@/views/pages/user/Timetable/AppointmentDetails.vue'),
    meta: {
      layout: 'content',
      title: 'bookingDetail',
      requireAuth: true,
      cannotAccess: cannotAccessList['AppointmentDetails'],
    },
  },
  {
    path: '/customer',
    name: 'CustomerList',
    component: () => import('@/views/pages/user/Customer/CustomerList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.customer',
      requireAuth: true,
      cannotAccess: cannotAccessList['CustomerList'],
    },
  },
  {
    path: '/customer/details/:id',
    name: 'CustomerDetails',
    component: () => import('@/views/pages/user/Customer/CustomerDetails.vue'),
    meta: {
      layout: 'content',
      title: 'userDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['CustomerDetails'],
    },
  },
  {
    path: '/customer/create',
    name: 'CreateCustomer',
    component: () => import('@/views/pages/user/Customer/CustomerDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createUser',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateCustomer'],
    },
  },
  {
    path: '/customer/attendance/:id',
    name: 'CustomerAttendance',
    component: () => import('@/views/pages/user/Customer/CustomerAttendance.vue'),
    meta: {
      layout: 'content',
      title: 'attendanceRecord',
      requireAuth: true,
      cannotAccess: cannotAccessList['CustomerAttendance'],
    },
  },
  {
    path: '/service',
    name: 'ServiceList',
    component: () => import('@/views/pages/user/Service/ServiceList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.allServices',
      requireAuth: true,
      cannotAccess: cannotAccessList['ServiceList'],
    },
  },
  {
    path: '/service/details/:id',
    name: 'ServiceDetails',
    component: () => import('@/views/pages/user/Service/ServiceDetails.vue'),
    meta: {
      layout: 'content',
      title: 'serviceDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['ServiceDetails'],
    },
  },
  {
    path: '/service/create',
    name: 'CreateService',
    component: () => import('@/views/pages/user/Service/ServiceDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createService',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateService'],
    },
  },
  {
    path: '/service-category',
    name: 'ServiceCategoryList',
    component: () => import('@/views/pages/user/Service/ServiceCategoryList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.serviceCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['ServiceCategoryList'],
    },
  },
  {
    path: '/service-category/create',
    name: 'CreateServiceCategory',
    component: () => import('@/views/pages/user/Service/ServiceCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateServiceCategory'],
    },
  },
  {
    path: '/service-category/details/:id',
    name: 'ServiceCategoryDetails',
    component: () => import('@/views/pages/user/Service/ServiceCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'serviceCategoryDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['ServiceCategoryDetails'],
    },
  },
  {
    path: '/general-service-category',
    name: 'GeneralServiceCategoryList',
    component: () => import('@/views/pages/user/Service/GeneralServiceCategoryList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.generalServiceCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['GeneralServiceCategoryList'],
    },
  },
  {
    path: '/general-service-category/create',
    name: 'CreateGeneralServiceCategory',
    component: () => import('@/views/pages/user/Service/GeneralServiceCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createGeneralServiceCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateGeneralServiceCategory'],
    },
  },
  {
    path: '/general-service-category/details/:id',
    name: 'GeneralServiceCategoryDetails',
    component: () => import('@/views/pages/user/Service/GeneralServiceCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'generalServiceCategoryDetail',
      requireAuth: true,
      cannotAccess: cannotAccessList['GeneralServiceCategoryDetails'],
    },
  },
  {
    path: '/order/:sid?',
    name: 'OrderList',
    component: () => import('@/views/pages/user/Order/OrderList.vue'),
    meta: {
      layout: 'content',
      title: 'recentInvoice',
      requireAuth: true,
      cannotAccess: cannotAccessList['OrderList'],
    },
  },
  {
    path: '/month-order/:sid?',
    name: 'MonthOrderList',
    component: () => import('@/views/pages/user/MonthOrder/MonthOrderList.vue'),
    meta: {
      layout: 'content',
      title: '',
      requireAuth: true,
      cannotAccess: cannotAccessList['OrderList'],
    },
  },
  {
    path: '/product',
    name: 'ProductList',
    component: () => import('@/views/pages/user/Product/ProductList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.product',
      requireAuth: true,
      cannotAccess: cannotAccessList['ProductList'],
    },
  },
  {
    path: '/product/details/:id',
    name: 'ProductDetails',
    component: () => import('@/views/pages/user/Product/ProductDetails.vue'),
    meta: {
      layout: 'content',
      title: 'productDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['ProductDetails'],
    },
  },
  {
    path: '/product/create',
    name: 'CreateProduct',
    component: () => import('@/views/pages/user/Product/ProductDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createProduct',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateProduct'],
    },
  },
  {
    path: '/product-category',
    name: 'ProductCategoryList',
    component: () => import('@/views/pages/user/Product/ProductCategoryList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.productCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['ProductCategoryList'],
    },
  },
  {
    path: '/product-category/details/:id',
    name: 'ProductCategoryDetails',
    component: () => import('@/views/pages/user/Product/ProductCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'productCategoryDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['ProductCategoryDetails'],
    },
  },
  {
    path: '/product-category/create',
    name: 'CreateProductCategory',
    component: () => import('@/views/pages/user/Product/ProductCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateProductCategory'],
    },
  },
  {
    path: '/room',
    name: 'RoomList',
    component: () => import('@/views/pages/user/Room/RoomList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.room',
      requireAuth: true,
      cannotAccess: cannotAccessList['RoomList'],
    },
  },
  {
    path: '/room/details/:id',
    name: 'RoomDetails',
    component: () => import('@/views/pages/user/Room/RoomDetails.vue'),
    meta: {
      layout: 'content',
      title: 'roomDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['RoomDetails'],
    },
  },
  {
    path: '/room/create',
    name: 'CreateRoom',
    component: () => import('@/views/pages/user/Room/RoomDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createRoom',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateRoom'],
    },
  },
  {
    path: '/branch',
    name: 'CenterList',
    component: () => import('@/views/pages/user/Center/CenterList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.campus',
      requireAuth: true,
      cannotAccess: cannotAccessList['CenterList'],
    },
  },
  {
    path: '/branch/details/:id',
    name: 'CenterDetails',
    component: () => import('@/views/pages/user/Center/CenterDetails.vue'),
    meta: {
      layout: 'content',
      title: 'campusDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['CenterDetails'],
    },
  },
  {
    path: '/branch/create',
    name: 'CreateCenter',
    component: () => import('@/views/pages/user/Center/CenterDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createCampus',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateCenter'],
    },
  },
  {
    path: '/staff',
    name: 'StaffList',
    component: () => import('@/views/pages/user/Staff/StaffList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.staff',
      requireAuth: true,
      cannotAccess: cannotAccessList['StaffList'],
    },
  },
  {
    path: '/staff/details/:id',
    name: 'StaffDetails',
    component: () => import('@/views/pages/user/Staff/StaffDetails.vue'),
    meta: {
      layout: 'content',
      title: 'staffDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['StaffDetails'],
    },
  },
  {
    path: '/staff/create',
    name: 'CreateStaff',
    component: () => import('@/views/pages/user/Staff/StaffDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createStaff',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateStaff'],
    },
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/pages/user/Setting.vue'),
    meta: {
      layout: 'content',
      title: 'menu.setting',
      requireAuth: true,
      cannotAccess: cannotAccessList['Setting'],
    },
  },
  {
    path: '/package-category',
    name: 'PackageCategoryList',
    component: () => import('@/views/pages/user/Package/PackageCategoryList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.packageCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['PackageCategoryList'],
    },
  },
  {
    path: '/package-category/details/:id',
    name: 'PackageCategoryDetails',
    component: () => import('@/views/pages/user/Package/PackageCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'packageCategoryDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['PackageCategoryDetails'],
    },
  },
  {
    path: '/package-category/create',
    name: 'CreatePackageCategory',
    component: () => import('@/views/pages/user/Package/PackageCategoryDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createPackageCategory',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreatePackageCategory'],
    },
  },
  {
    path: '/package',
    name: 'PackageList',
    component: () => import('@/views/pages/user/Package/PackageList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.allPackages',
      requireAuth: true,
      cannotAccess: cannotAccessList['PackageList'],
    },
  },
  {
    path: '/package/details/:id',
    name: 'PackageDetails',
    component: () => import('@/views/pages/user/Package/PackageDetails.vue'),
    meta: {
      layout: 'content',
      title: 'packageDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['PackageDetails'],
    },
  },
  {
    path: '/package/create',
    name: 'CreatePackage',
    component: () => import('@/views/pages/user/Package/PackageDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createPackage',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreatePackage'],
    },
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('@/views/pages/user/Report.vue'),
    meta: {
      layout: 'content',
      title: 'menu.report',
      requireAuth: true,
      cannotAccess: cannotAccessList['Report'],
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/pages/user/Dashboard.vue'),
    meta: {
      layout: 'content',
      title: 'menu.dashboard',
      requireAuth: true,
      cannotAccess: cannotAccessList['Dashboard'],
    },
  },

  {
    path: '/agreement',
    name: 'AgreementList',
    component: () => import('@/views/pages/user/Agreement/AgreementList.vue'),
    meta: {
      layout: 'content',
      title: 'menu.agreement',
      requireAuth: true,
      cannotAccess: cannotAccessList['AgreementList'],
    },
  },
  {
    path: '/agreement/create',
    name: 'CreateAgreement',
    component: () => import('@/views/pages/user/Agreement/AgreementDetails.vue'),
    meta: {
      layout: 'content',
      title: 'createAgreement',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateAgreement'],
    },
  },
  {
    path: '/agreement/details/:id',
    name: 'AgreementDetails',
    component: () => import('@/views/pages/user/Agreement/AgreementDetails.vue'),
    meta: {
      layout: 'content',
      title: 'agreementDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['AgreementDetails'],
    },
  },

  {
    path: '/shift-code',
    name: 'ShiftCode',
    component: () => import('@/views/pages/user/Shift/ShiftCode.vue'),
    meta: {
      layout: 'content',
      title: 'shiftCode',
      requireAuth: true,
      cannotAccess: cannotAccessList['ShiftCode'],
    },
  },

  {
    path: '/shift-code/create',
    name: 'CreateShiftCode',
    component: () => import('@/views/pages/user/Shift/ShiftCodeDetail.vue'),
    meta: {
      layout: 'content',
      title: 'newShiftCode',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateShiftCode'],
    },
  },
  {
    path: '/shift-code/details/:id',
    name: 'ShiftCodeDetails',
    component: () => import('@/views/pages/user/Shift/ShiftCodeDetail.vue'),
    meta: {
      layout: 'content',
      title: 'shiftCodeDetails',
      requireAuth: true,
      cannotAccess: cannotAccessList['ShiftCodeDetails'],
    },
  },

  {
    path: '/shift-control',
    name: 'ShiftControl',
    component: () => import('@/views/pages/user/Shift/ShiftControl.vue'),
    meta: {
      layout: 'content',
      title: 'shiftControl',
      requireAuth: true,
      cannotAccess: cannotAccessList['ShiftControl'],
    },
  },

  {
    path: '/shift-staff-count',
    name: 'ShiftStaffCount',
    component: () => import('@/views/pages/user/Shift/ShiftStaffCount.vue'),
    meta: {
      layout: 'content',
      title: 'shiftStaffCount',
      requireAuth: true,
      cannotAccess: cannotAccessList['ShiftStaffCount'],
    },
  },

  {
    path: '/shift-hr-count',
    name: 'ShiftHourCount',
    component: () => import('@/views/pages/user/Shift/ShiftHourCount.vue'),
    meta: {
      layout: 'content',
      title: 'shiftHourCount',
      requireAuth: true,
      cannotAccess: cannotAccessList['ShiftHourCount'],
    },
  },

  {
    path: '/daily-shift-hr',
    name: 'DailyShiftHour',
    component: () => import('@/views/pages/user/Shift/DailyShiftHour.vue'),
    meta: {
      layout: 'content',
      title: 'dailyShiftHour',
      requireAuth: true,
      cannotAccess: cannotAccessList['DailyShiftHour'],
    },
  },

  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
      title: 'Error',
      skipAuth: true,
    },
  },
]
